(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSMovimientoEstatusProyectoController', SSMovimientoEstatusProyectoController);

    SSMovimientoEstatusProyectoController.$inject = ['SSMovimientoEstatusProyecto'];

    function SSMovimientoEstatusProyectoController(SSMovimientoEstatusProyecto) {

        var vm = this;

        vm.sSMovimientoEstatusProyectos = [];

        loadAll();

        function loadAll() {
            SSMovimientoEstatusProyecto.query(function(result) {
                vm.sSMovimientoEstatusProyectos = result;
                vm.searchQuery = null;
            });
        }
    }
})();
